





























import {Component, Prop, Vue} from "vue-property-decorator";
import {InputType} from "@/componentsReusable/InputType";
import MaskedInput from 'vue-text-mask';
import flatPickr from 'vue-flatpickr-component';
import { Fragment } from 'vue-fragment';
import {Money} from 'v-money';

@Component({
  components: {
    MaskedInput,
    flatPickr,
    Fragment,
    Money
  }
})
export default class InputAndError extends Vue {
  @Prop({type:String, required:true})
  protected label!: string;

  @Prop({type:String, required:true})
  protected inputId!: string;

  @Prop({type:Object, required:true})
  protected entity!: any;

  @Prop({type:String, required:true})
  protected fieldName!: any;

  @Prop({type:Boolean, default: false})
  protected disabled!: any;

  @Prop({type:Number, required:true})
  protected inputType!: InputType;

  protected InputType = InputType;

  protected money = {
    decimal: '.',
    thousands: ',',
    prefix: '$',
    precision: 2
  };

  protected stateSelected(state: any, row:any) {
    row.stateId = state.id;
    row.state = state.stateFull;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/InputAndError.vue